import { useFormContext } from "react-hook-form";

import { Card, CardContent, CardTitle } from "@/components/ui/card";
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Textarea } from "@/components/ui/textarea";
import type { QuoteFormSchema } from "@/lib/schemas/createUpdateQuoteSchema";

export default function ScopeDescription() {
  const form = useFormContext<QuoteFormSchema>();
  return (
    <Card className="p-10">
      <CardTitle>Scope Description</CardTitle>
      <CardContent className="p-0 pt-10">
        <FormField
          control={form.control}
          name="scopeDescription"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Scope Description</FormLabel>
              <FormControl>
                <Textarea placeholder="Scope Description" className="resize-none" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </CardContent>
    </Card>
  );
}
